import React from 'react';
import '../styles/TermCard.css'; // Import the TermCard.css

const TermCard = ({ term, setSelectedTerm }) => {
  const handleTermClick = () => {
    setSelectedTerm(term);
  };

  return (
    <div className="term-card" onClick={handleTermClick}>
      <h3>{term.term}</h3>
      {/* <p>{term.origin}</p> */}
    </div>
     
  );
};

export default TermCard;